import { isFunction, get } from 'lodash';

// import all animation configuration
import * as DEFAULT_ANIMATION_CONFIG from './config';
import * as CUSTOM_ANIMATION_CONFIG from 'ui/animations/config';

/**
 * @desc this function returns animation configuration function based on animation name
 * @param {*} animationName - Name of the animation
 */
export const getAnimationConfig = ( animationName, extraConfig ) => {

    // get animation config function from animation name
    const configFunction = get( CUSTOM_ANIMATION_CONFIG, animationName, DEFAULT_ANIMATION_CONFIG[ animationName ] );

    // return animation config object by calling `configFunction` with extra config
    return isFunction( configFunction ) ? configFunction( extraConfig ) : {};

};
